export const REDIRECT_TO_PARAM_NAME = 'redirectTo';
export const WITH_EXPIRED_SESSION_PARAM_NAME = 'withExpiredSession';

export const HOMEPAGE_PATHNAME = '/';

export const VERIFY_OTP_TIMEOUT = 1 * 60 * 1000; // 1 minute

export const PAYMENT_TYPES = {
  DEPOSITS: 'deposits',
  WITHDRAWALS: 'withdrawals',
} as const;

/**
 * The values are in CENTS only for USD currency.
 */
export const QUICK_DEPOSIT_AMOUNTS: { [key in string]: Array<{ value: number; isDefault?: boolean }> } = {
  USD: [
    { value: 1000 },
    { value: 2000 },
    { value: 5000, isDefault: true },
    { value: 10000 },
    { value: 20000 },
    { value: 50000 },
    { value: 100000 },
  ],
  IRT: [
    { value: 500000 },
    { value: 1000000, isDefault: true },
    { value: 2000000 },
    { value: 3000000 },
    { value: 4000000 },
    { value: 5000000 },
    { value: 10000000 },
  ],
} as const;

/**
 * The values are in CENTS only for USD currency.
 */
export const QUICK_WITHDRAWAL_AMOUNTS: { [key in string]: Array<{ value: number; isDefault?: boolean }> } = {
  USD: [
    { value: 1000 },
    { value: 2000 },
    { value: 5000, isDefault: true },
    { value: 10000 },
    { value: 20000 },
    { value: 50000 },
    { value: 100000 },
  ],
  IRT: [
    { value: 500000 },
    { value: 1000000 },
    { value: 2000000 },
    { value: 3000000 },
    { value: 4000000 },
    { value: 5000000 },
    { value: 6000000 },
    { value: 7000000 },
    { value: 8000000 },
    { value: 9000000 },
    { value: 10000000 },
    { value: 15000000 },
    { value: 20000000 },
    { value: 25000000 },
    { value: 30000000 },
  ],
} as const;

export const APP_REVALIDATE_TAGS = {
  PROFILE: 'profile',
} as const;

export const APP_REVALIDATE_QUERY_NAMES = {
  WALLET_BALANCE: 'wallet-balance',
  WALLET_BALANCES: 'wallet-balances',
  PROFILE: 'profile',
  CASINO_HISTORY: 'casino-history',
  SPORTS_HISTORY: 'sports-history',
  REFERRALS: 'referrals',
  DEPOSITS_HISTORY: 'deposits-history',
  WITHDRAWALS_HISTORY: 'withdrawals-history',
  WITHDRAW_LIMITS: 'withdraw-limits',
  GAME_LAUNCH_URL: 'game-launch-url',
  PAYMENT_METHODS: 'payment-methods',
  BONUS_HISTORY: 'bonus-history',
  MAX_DEPOSITS_COUNT: 'max-deposits-count',
  TENANT_GATEWAY_CONFIG: 'tenant-gateway-config',
  CASINO_GAMES_TYPES: 'casino-games-types',
  CASINO_GAMES_PROVIDERS: 'casino-games-providers',
  CASINO_GAMES: 'casino-games',
  METHOD_WALLET_ADDRESSES: 'method-wallet-addresses',
} as const;

export const APP_REVALIDATE_QUERY_TIMES = {
  BANNERS: 1000 * 60 * 60 * 3, // 3 hours
  CASINO_GAMES: 1000 * 60 * 60 * 24 * 5, // 5 days
  CASINO_GAMES_SEARCH: 1000 * 60 * 60 * 24, // 1 day
} as const;

export const DEFAULT_PAGINATION_LIMIT = 50;

/**
 * This list includes all the possible statuses for a transaction (deposit or withdrawal).
 */
export const TRANSACTION_STATUSES: Record<string, string> = {
  REQUESTED: 'REQUESTED',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  ACCEPTED: 'ACCEPTED',
  FAILED: 'FAILED',
  GATEWAY_ERROR: 'GATEWAY_ERROR',
  APPROVED: 'APPROVED',
  UNKNOWN: 'UNKNOWN',
} as const;

export const REGEX_PATTERNS = {
  // E.164 phone number format validation
  // Allows: +1234567890, +44 1234 567890, etc.
  PHONE_NUMBER: /^\+[1-9]\d{1,14}$/,

  NAME_REGEX: /^[a-zA-Z]+( [a-zA-Z]+)*$/,

  // Wallet address validation for different cryptocurrencies
  WALLET_ADDRESS: {
    TRC20: /^T[a-zA-Z0-9]{33}$/,
    ERC20: /^0x[a-fA-F0-9]{40}$/,
    TRON: /^T[a-zA-Z0-9]{33}$/,
    Ethereum: /^0x[a-fA-F0-9]{40}$/,
    Bitcoin: /^(1[a-zA-Z0-9]{25,34}|3[a-zA-Z0-9]{25,34}|bc1[a-zA-Z0-9]{39,59})$/,
    BEP20: /^0x[a-fA-F0-9]{40}$/,
    BNB: /^0x[a-fA-F0-9]{40}$/,
    Solana: /^[1-9A-HJ-NP-Za-km-z]{32,44}$/,
  },
} as const;

export const RESTRICTED_COUNTRIES_ISO_CODES: Record<string, string> = {
  // AU: 'Australia',
  // AT: 'Austria',
  KM: 'Comoros Islands',
  // FR: 'France',
  // DE: 'Germany',
  // NL: 'Netherlands',
  // ES: 'Spain',
  GB: 'United Kingdom',
  // US: 'United States',
  KP: "Democratic People's Republic of Korea",
  IR: 'Iran',
  // MM: 'Myanmar',
  AE: 'United Arab Emirates',
};

export const AFFILKA_ID_PARAM_NAME = 'stag';
export const REFERRAL_CODE_PARAM_NAME = 'referralCode';

export const TENANT_COOKIE_NAME = 'vatan-platform-tenant-override-v65';
